import { render, staticRenderFns } from "./delivery-time.vue?vue&type=template&id=3fe0e3f0&scoped=true"
import script from "./delivery-time.vue?vue&type=script&lang=js"
export * from "./delivery-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe0e3f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe0e3f0')) {
      api.createRecord('3fe0e3f0', component.options)
    } else {
      api.reload('3fe0e3f0', component.options)
    }
    module.hot.accept("./delivery-time.vue?vue&type=template&id=3fe0e3f0&scoped=true", function () {
      api.rerender('3fe0e3f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/public/delivery-time.vue"
export default component.exports